export default "__VITE_ASSET__ClV0MRVX__"